
import { WorldCountry } from '../types';

export const fiji: WorldCountry = {
  code: 'FJ',
  name: 'Fiji',
  slug: 'fiji',
  population: 896445,
  topCities: [
    { name: 'Suva', slug: 'suva', population: 93970 },
    { name: 'Nasinu', slug: 'nasinu', population: 92043 },
    { name: 'Lautoka', slug: 'lautoka', population: 71573 },
    { name: 'Nadi', slug: 'nadi', population: 71048 },
    { name: 'Labasa', slug: 'labasa', population: 27949 },
    
    // Expansión: 95 ciudades adicionales para llegar a 100 total
    { name: 'Ba', slug: 'ba-fiji', population: 14596 },
    { name: 'Levuka', slug: 'levuka', population: 1131 },
    { name: 'Sigatoka', slug: 'sigatoka', population: 9622 },
    { name: 'Tavua', slug: 'tavua', population: 2418 },
    { name: 'Rakiraki', slug: 'rakiraki', population: 4906 },
    { name: 'Korovou', slug: 'korovou', population: 3051 },
    { name: 'Navua', slug: 'navua', population: 4844 },
    { name: 'Denarau', slug: 'denarau', population: 3000 },
    { name: 'Pacific Harbour', slug: 'pacific-harbour', population: 2500 },
    { name: 'Nausori', slug: 'nausori', population: 57882 },
    { name: 'Savusavu', slug: 'savusavu', population: 3372 },
    { name: 'Taveuni', slug: 'taveuni', population: 19054 },
    { name: 'Seaqaqa', slug: 'seaqaqa', population: 2500 },
    { name: 'Vatukoula', slug: 'vatukoula', population: 1929 },
    { name: 'Nabouwalu', slug: 'nabouwalu', population: 1120 },
    { name: 'Vunidawa', slug: 'vunidawa', population: 1500 },
    { name: 'Keiyasi', slug: 'keiyasi', population: 800 },
    { name: 'Bukuya', slug: 'bukuya', population: 1200 },
    { name: 'Nadarivatu', slug: 'nadarivatu', population: 500 },
    { name: 'Monasavu', slug: 'monasavu', population: 200 },
    { name: 'Waidalice', slug: 'waidalice', population: 300 },
    { name: 'Namalata', slug: 'namalata', population: 400 },
    { name: 'Namosi', slug: 'namosi', population: 600 },
    { name: 'Vunisea', slug: 'vunisea', population: 1300 },
    { name: 'Rotuma', slug: 'rotuma', population: 2002 },
    { name: 'Ahau', slug: 'ahau', population: 300 },
    { name: 'Oinafa', slug: 'oinafa', population: 400 },
    { name: 'Motusa', slug: 'motusa', population: 350 },
    { name: 'Malhaha', slug: 'malhaha', population: 280 },
    { name: 'Losa', slug: 'losa', population: 320 },
    { name: 'Tuakoi', slug: 'tuakoi', population: 250 },
    { name: 'Kalvoka', slug: 'kalvoka', population: 200 },
    { name: 'Nasau', slug: 'nasau', population: 180 },
    { name: 'Joma', slug: 'joma', population: 150 },
    { name: 'Hapmak', slug: 'hapmak', population: 120 },
    { name: 'Fapufa', slug: 'fapufa', population: 100 },
    { name: 'Sisilo', slug: 'sisilo', population: 90 },
    { name: 'Itu\'ti\'u', slug: 'itutiu', population: 80 },
    { name: 'Uea', slug: 'uea', population: 70 },
    { name: 'Noatau', slug: 'noatau', population: 60 },
    { name: 'Savlei', slug: 'savlei', population: 50 },
    { name: 'Lau Group', slug: 'lau-group', population: 10683 },
    { name: 'Lakeba', slug: 'lakeba', population: 2100 },
    { name: 'Tubou', slug: 'tubou', population: 2000 },
    { name: 'Nayau', slug: 'nayau', population: 400 },
    { name: 'Cicia', slug: 'cicia', population: 300 },
    { name: 'Tuvuca', slug: 'tuvuca', population: 250 },
    { name: 'Kabara', slug: 'kabara', population: 200 },
    { name: 'Fulaga', slug: 'fulaga', population: 150 },
    { name: 'Ogea', slug: 'ogea', population: 120 },
    { name: 'Vatoa', slug: 'vatoa', population: 100 },
    { name: 'Ono-i-Lau', slug: 'ono-i-lau', population: 90 },
    { name: 'Vanua Balavu', slug: 'vanua-balavu', population: 800 },
    { name: 'Lomaloma', slug: 'lomaloma', population: 600 },
    { name: 'Susui', slug: 'susui', population: 200 },
    { name: 'Daliconi', slug: 'daliconi', population: 150 },
    { name: 'Narocivo', slug: 'narocivo', population: 100 },
    { name: 'Mavana', slug: 'mavana', population: 80 },
    { name: 'Lomaiviti', slug: 'lomaiviti', population: 16461 },
    { name: 'Ovalau', slug: 'ovalau', population: 9000 },
    { name: 'Rukuruku', slug: 'rukuruku', population: 1200 },
    { name: 'Lovoni', slug: 'lovoni', population: 800 },
    { name: 'Bureta', slug: 'bureta', population: 600 },
    { name: 'Gau', slug: 'gau', population: 3000 },
    { name: 'Somosomo', slug: 'somosomo-gau', population: 1500 },
    { name: 'Navukailagi', slug: 'navukailagi', population: 800 },
    { name: 'Sawaieke', slug: 'sawaieke', population: 700 },
    { name: 'Koro', slug: 'koro', population: 4100 },
    { name: 'Nasau', slug: 'nasau-koro', population: 2000 },
    { name: 'Mudu', slug: 'mudu', population: 1000 },
    { name: 'Tailevu', slug: 'tailevu', population: 800 },
    { name: 'Batiki', slug: 'batiki', population: 500 },
    { name: 'Nairai', slug: 'nairai', population: 400 },
    { name: 'Wakaya', slug: 'wakaya', population: 300 },
    { name: 'Makogai', slug: 'makogai', population: 250 },
    { name: 'Yanuca', slug: 'yanuca', population: 200 },
    { name: 'Leleuvia', slug: 'leleuvia', population: 150 },
    { name: 'Caqalai', slug: 'caqalai', population: 100 },
    { name: 'Kandavu Group', slug: 'kandavu-group', population: 10167 },
    { name: 'Vunisea', slug: 'vunisea-kandavu', population: 4000 },
    { name: 'Namalata', slug: 'namalata-kandavu', population: 2000 },
    { name: 'Kavala Bay', slug: 'kavala-bay', population: 1500 },
    { name: 'Drue', slug: 'drue', population: 1000 },
    { name: 'Nagigia', slug: 'nagigia', population: 800 },
    { name: 'Nukuni', slug: 'nukuni', population: 600 },
    { name: 'Ono', slug: 'ono-kandavu', population: 400 },
    { name: 'Buliya', slug: 'buliya', population: 300 },
    { name: 'Galoa', slug: 'galoa', population: 250 },
    { name: 'Yaduataba', slug: 'yaduataba', population: 200 },
    { name: 'Nabukelevu', slug: 'nabukelevu', population: 150 },
    { name: 'Dravuni', slug: 'dravuni', population: 100 },
    { name: 'Beqa', slug: 'beqa', population: 2200 },
    { name: 'Malumu', slug: 'malumu', population: 1200 },
    { name: 'Dakuni', slug: 'dakuni', population: 800 },
    { name: 'Rukua', slug: 'rukua', population: 600 },
    { name: 'Soliyaga', slug: 'soliyaga', population: 400 },
    { name: 'Lalati', slug: 'lalati', population: 300 },
    { name: 'Yanuca', slug: 'yanuca-beqa', population: 200 }
  ]
};
